/*
Documentation

this reducer holds all the actions we can dispatch for our global user object

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../actions';

const initialState = {
    app_payments:     [],
    app_payments_this_week:     0,
    app_payments_total:     0,
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_APP_PAYMENTS:


            return {
                ...state,
                app_payments: action.payload.objects
            }

        case actionTypes.SET_APP_PAYMENTS_THIS_WEEK:


            return {
                ...state,
                app_payments_this_week: action.payload.objects
            }

        case actionTypes.SET_APP_PAYMENTS_TOTAL:


            return {
                ...state,
                app_payments_total: action.payload.objects
            }

        default:
        

            return state;
    }
}



export default reducer;